
import React from "react";

const chair = (x, y, r = 3.2) => (
  <circle cx={x} cy={y} r={r} fill="currentColor" />
);

const table = (x, y, width, height, rx = 3) => (
  <rect
    x={x}
    y={y}
    width={width}
    height={height}
    rx={rx}
    fill="currentColor"
    opacity="0.78"
  />
);

function Theatre() {
  return (
    <g>
      {Array.from({ length: 5 }, (_, row) =>
        Array.from({ length: 7 }, (_, col) =>
          chair(15 + col * 15, 18 + row * 13, 4.5)
        )
      )}
    </g>
  );
}

function Classroom() {
  return (
    <g>
      {table(39, 8, 42, 7, 3)}
      {Array.from({ length: 4 }, (_, row) =>
        [18, 43, 77, 102].map((x) => (
          <React.Fragment key={`${row}-${x}`}>
            {table(x - 6, 25 + row * 14, 12, 7, 2)}
            {chair(x, 35 + row * 14, 3)}
          </React.Fragment>
        ))
      )}
    </g>
  );
}

function Banquet() {
  const centers = [
    [25, 25], [60, 20], [95, 25],
    [42, 48], [78, 48], [25, 70],
    [60, 72], [95, 70],
  ];

  return (
    <g>
      {centers.map(([x, y], i) => (
        <g key={i}>
          <circle cx={x} cy={y} r="8" fill="currentColor" opacity=".72" />
          {Array.from({ length: 6 }, (_, j) => {
            const angle = (j * Math.PI) / 3;
            return chair(
              x + Math.cos(angle) * 12,
              y + Math.sin(angle) * 12,
              2.8
            );
          })}
        </g>
      ))}
    </g>
  );
}

function Boardroom() {
  return (
    <g>
      {table(39, 10, 42, 70, 15)}
      {[20, 34, 48, 62, 76].map((y) => (
        <React.Fragment key={y}>
          {chair(30, y)}
          {chair(90, y)}
        </React.Fragment>
      ))}
      {chair(49, 6)}
      {chair(71, 6)}
      {chair(49, 84)}
      {chair(71, 84)}
    </g>
  );
}

function UShape() {
  return (
    <g>
      {table(28, 12, 12, 61)}
      {table(80, 12, 12, 61)}
      {table(28, 65, 64, 12)}
      {[20, 34, 48, 62].map((y) => (
        <React.Fragment key={y}>
          {chair(22, y)}
          {chair(98, y)}
        </React.Fragment>
      ))}
      {[40, 55, 70, 85].map((x) => chair(x, 83))}
      {chair(48, 5)}
      {chair(72, 5)}
    </g>
  );
}

function EShape() {
  return (
    <g>
      {table(28, 10, 10, 70)}
      {table(28, 10, 53, 10)}
      {table(28, 39, 53, 10)}
      {table(28, 70, 53, 10)}
      {[20, 34, 48, 62, 76].map((y) => chair(20, y))}
      {[48, 62, 76].map((x) => (
        <React.Fragment key={x}>
          {chair(x, 26)}
          {chair(x, 55)}
          {chair(x, 86)}
        </React.Fragment>
      ))}
    </g>
  );
}

function TShape() {
  return (
    <g>
      {table(20, 12, 80, 11)}
      {table(54, 12, 12, 67)}
      {[30, 46, 62, 78, 94].map((x) => chair(x, 6))}
      {[29, 43, 57, 71, 82].map((y) => (
        <React.Fragment key={y}>
          {chair(46, y)}
          {chair(74, y)}
        </React.Fragment>
      ))}
    </g>
  );
}

function Cocktail() {
  return (
    <g>
      {[[25, 25], [60, 20], [95, 25], [40, 55], [80, 55]].map(
        ([x, y], i) => (
          <g key={i}>
            <circle cx={x} cy={y} r="6" fill="currentColor" opacity=".72" />
            {chair(x, y - 10, 2.5)}
            {chair(x + 10, y, 2.5)}
            {chair(x, y + 10, 2.5)}
            {chair(x - 10, y, 2.5)}
          </g>
        )
      )}
    </g>
  );
}

function Cluster() {
  return (
    <g>
      {[[30, 24], [60, 24], [90, 24], [30, 55], [60, 55], [90, 55]].map(
        ([x, y], i) => (
          <g key={i}>
            {table(x - 8, y - 5, 16, 10, 3)}
            {chair(x - 9, y - 9, 2.5)}
            {chair(x + 9, y - 9, 2.5)}
            {chair(x - 9, y + 9, 2.5)}
            {chair(x + 9, y + 9, 2.5)}
          </g>
        )
      )}
    </g>
  );
}

const layouts = {
  theatre: Theatre,
  classroom: Classroom,
  u_shape: UShape,
  boardroom: Boardroom,
  round_table: Banquet,
  banquet: Banquet,
  cocktail: Cocktail,
  cluster: Cluster,
  e_shape: EShape,
  t_shape: TShape,
};

export default function SeatingLayoutIcon({ type, className = "" }) {
  const Layout = layouts[type] || Cluster;

  return (
    <svg
      className={className}
      viewBox="0 0 120 90"
      role="img"
      aria-label={`${type.replace(/_/g, " ")} seating arrangement`}
      xmlns="http://www.w3.org/2000/svg"
    >
      <Layout />
    </svg>
  );
}
